import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OemRooftopLink } from '@quorum/models/xs-resource';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';
import { Observable } from 'rxjs';

@Component({
  selector: 'svc-dashboard-shell',
  templateUrl: './dashboard-shell.component.html',
  styleUrls: ['./dashboard-shell.component.scss'],
})
export class DashboardShellComponent implements OnInit {
  //oem$: Observable<OemRooftopLink>;
  params: any;
  constructor(private serviceLaneFacade: ServiceLaneFacade, private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.route.snapshot.queryParams) {
      this.params = this.route.snapshot.queryParams;
      this.serviceLaneFacade.dashboardSubject$.next({
        params: {
          oemrtId: this.params.oemrtId,
          vehicleVin: this.params.vehicleVin,
          odometerIn: this.params.odometerIn === 'null' ? null : this.params.odometerIn,
          vehicleId: this.params.vehicleId,
          employeeId: this.params.employeeId,
          oem: this.params.oem,
          vehicleYear: this.params.vehicleYear,
        },
        skipCache: false,
      });
    }
  }
}
